// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bond-giveback-list-page[data-v-3df085ca]{background-color:#fff;width:100%;height:calc(100% - 1.5625rem);border-radius:.520833rem;overflow:hidden;margin-bottom:1.5625rem}.bond-giveback-list-page .content-box[data-v-3df085ca]{padding:1.041667rem}.bond-giveback-list-page .content-box[data-v-3df085ca] .el-button--text{padding:0;margin:0}", ""]);
// Exports
module.exports = exports;
